import React, { useEffect, useRef, useState } from "react";

// api
import axios from "axios";

// router
import { useLocation, useNavigate, useParams } from "react-router";

// Config
import { ENDPOINTS } from "../../js/api/_config";

// Components
import Header from "../common/header/Header";
import LeftConversationList from "./left-conversation-list";
import ChatBody from "./chat-body";

// icons
import NoConversation from "../../assets/images/no-conversation-vector.svg";

// Redux
import { useDispatch, useSelector } from "react-redux";

// Slices
import { setCallData } from "../../reducer/slices/twilio-calls/call-slice";
import { fetchUnreadCount } from "../../reducer/slices/notifications/unread-count";
import { useSignalR } from "../../context/Signalr-context";

const ConversationList = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [call, setCall] = useState(false);
  const [allConList, getAllConList] = useState([]);
  const [allTrial, getAllTrial] = useState([]);
  const [allTrialUnread, getAllTrialUnread] = useState([]);
  const [selectedChatId, setSelectedChatId] = useState(id);
  const [getConversation, setGetConversation] = useState([]);
  const [currentChat, setCurrentChat] = useState({});
  const [search, setSearch] = useState("");
  const [showClose, setShowClose] = useState(false);
  const [mainChatList, setChatPatientList] = useState([]);
  const [unreadState, setUnreadState] = useState([]);
  const [noRecruiter, setNoRecruiter] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [trialInfo, setTrialInfo] = useState(null);
  const [query, setQuery] = useState("");
  const [callDispatch, setCallDispatch] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [prevSelectedFilter, setPrevSelectedFilter] = useState([]);
  const [isApplyFilters, setApplyFilters] = useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const resetRef = useRef(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const POLLING_INTERVAL = 5000;
  const PAGE_SIZE = 10;
  const { hubConnection } = useSignalR();

  // --- Conversation Type ---
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const conversationType = queryParams.get("conversation_type") || "";
  const [isUnread, setIsUnread] = useState(
    conversationType ? conversationType : "unread",
  );
  const callDispatchRef = useRef(true);

  // --- Pagination states ---
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [listLoading, setListLoading] = useState(false);
  const [pageUnread, setPageUnread] = useState(1);
  const [hasMoreUnread, setHasMoreUnread] = useState(true);
  // --- Pagination fetch function ---
  const fetchPaginatedConversation = async (
    tab = "all",
    reset = false,
    search = "",
    trialIdList = isApplyFilters ? selectedFilter : [],
  ) => {
    const isUnreadTab = tab === "unread";

    if (listLoading) return;

    // 🔹 Decide which page to use
    let currentPage = isUnreadTab ? pageUnread : page;

    if (reset) {
      currentPage = 1;

      if (isUnreadTab) {
        setPageUnread(1);
        setHasMoreUnread(true);
        getAllTrialUnread([]);
      } else {
        setPage(1);
        setHasMore(true);
        getAllTrial([]);
      }

      setInitialLoadComplete(false);
    } else {
      if (isUnreadTab && !hasMoreUnread) return;
      if (!isUnreadTab && !hasMore) return;
    }

    setListLoading(true);

    try {
      const response = await axios.get(
        `${ENDPOINTS.CONVERSATION.GET_ALL_CONVERSATION}`,
        {
          params: {
            Page: currentPage,
            PageSize: PAGE_SIZE,
            SearchTerm: search || "",
            IsUnread: isUnreadTab ? true : "",
            trialIDs: isApplyFilters ? trialIdList.join(",") : "",
          },
        },
      );

      const totalCount = response?.data?.data?.items.length || 0;

      const newData = Array.isArray(response?.data?.data?.items)
        ? response.data.data.items
        : [];

      if (isUnreadTab) {
        getAllTrialUnread((prev) => {
          const updatedData = reset ? newData : [...prev, ...newData];

          const hasNext = newData.length === PAGE_SIZE;

          setHasMoreUnread(hasNext);

          console.log("UNREAD DEBUG →", {
            currentPage,
            totalCount,
            newDataLength: newData.length,
            previousLength: allTrialUnread.length,
            updatedData: updatedData.length,
          });

          if (hasNext) {
            setPageUnread((prevPage) => prevPage + 1);
          }

          return updatedData;
        });
      } else {
        // 🔹 KEEP ALL TAB EXACTLY AS BEFORE
        getAllTrial((prev) => (reset ? newData : [...prev, ...newData]));

        const hasNext = newData.length === PAGE_SIZE;

        setHasMore(hasNext);

        if (hasNext) {
          setPage((prevPage) => prevPage + 1);
        }
      }

      setInitialLoadComplete(true);
    } catch (err) {
      console.error("Pagination error:", err);
    }

    setListLoading(false);
  };

  // --- Update unread state from child ---
  const updateUnreadState = (selectedChatId, isUnread) => {
    setUnreadState((prevState) => {
      const updatedState = [...prevState];
      const messageIndex = updatedState.findIndex(
        (msg) => msg.selectedChatId === selectedChatId,
      );

      if (isUnread && messageIndex === -1) {
        updatedState.push({ selectedChatId, isUnread });
      } else if (!isUnread && messageIndex !== -1) {
        updatedState.splice(messageIndex, 1);
      }
      return updatedState;
    });
    // console.log('fetchUnreadCount called 2')
    getAllTrial((prevAllTrial) =>
      prevAllTrial.map((msg) =>
        msg.patientTrialJuncID === selectedChatId ? { ...msg, isUnread } : msg,
      ),
    );
  };

  // --- Initial fetch ---
  useEffect(() => {
    fetchPaginatedConversation(isUnread, true, query, selectedFilter);
  }, [isUnread]);

  useEffect(() => {
    if(isApplyFilters){
      fetchPaginatedConversation(isUnread, true, query, selectedFilter);
    }
  }, [isApplyFilters]);

  useEffect(() => {
    if (!query) return; // ✅ prevents duplicate reset
    const handler = setTimeout(() => {
      fetchPaginatedConversation(isUnread, true, query);
    }, 500);
    return () => clearTimeout(handler);
  }, [query]);

  // --- Search functionality ---
  const onSearchClick = () => {
    if (!search) return;

    const lowerCaseSearchTerm = search.toLowerCase();
    const searchedValue = mainChatList.filter((item) =>
      item.patientName.toLowerCase().includes(lowerCaseSearchTerm),
    );

    getAllTrial(searchedValue);
    setShowClose(true);
  };

  const onCloseClick = () => {
    getAllTrial([...mainChatList]);
    setSearch("");
    setShowClose(false);
  };

  const onHandleSearch = (value) => {
    setQuery(value);
  };

  const clearSearch = () => {
    setQuery("");
    getAllTrial(mainChatList);
  };

  // --- Fetch particular chat ---
  const getParticularChat = async () => {
    await axios
      .get(
        `${ENDPOINTS.CONVERSATION.GET_CONVERSATION_BY_TRIAL_ID}?patientTrialJuncId=${selectedChatId}`,
      )
      .then((res) => {
        setTrialInfo({
          patientName: res.data.data.patientName,
          phoneNumber: res.data.data.phoneNumber,
          status: res.data.data.status,
          trialID: res.data.data.trialID,
          patientID: res.data.data.patientID,
          patientTrialJuncID: res.data.data.patientTrialJuncID,
          trialName: res.data.data.trialName,
          isChatByBot: res.data.data.isChatByBot,
          iSeclinProSync: res.data.data.iSeclinProSync,
          docuSignStatus: res.data.data.docuSignStatus,
          isCallInProgress: res.data.data.isCallInProgress,
          eclinProSyncResult: res.data.data.eclinProSyncResult,
          eclinProSyncStatus: res.data.data.eclinProSyncStatus,
        });

        if (
          res?.data?.data?.patientConversationNodes != null &&
          res?.data?.data?.patientConversationNodes?.length > 0
        ) {
          if (callDispatchRef.current) {
            callDispatchRef.current = false; // works only once
            console.log("called from here");
            dispatch(fetchUnreadCount());
          }

          setGetConversation(res.data.data.patientConversationNodes);
        } else {
          setGetConversation([]);
        }
      });

    await axios.get(
      `${ENDPOINTS.CONVERSATION.GET_UPDATED_CONVERSATION}?patientTrialJuncId=${selectedChatId}&read=true`,
    );

    updateUnreadState(selectedChatId, false);

    const selectedChatData = allConList.find(
      (chat) => chat.patientTrialJuncID === selectedChatId,
    );
    setCurrentChat(selectedChatData);
  };

  useEffect(() => {
    if (!hubConnection) return;
    
    const handleNotification = (message) => {
      
      const { event_type } = message;
      
      if (event_type === "Patient-Conversation-Incoming") {
        fetchPaginatedConversation(isUnread, true, query, selectedFilter)
      }
    };
  
    
    hubConnection.on("notification", handleNotification);
  
    
    return () => {
      hubConnection.off("notification", handleNotification);
    };
  
  }, [hubConnection]);

  useEffect(() => {
    setSelectedChatId(id);
  }, [id]);

  const removeFromUnread = async () => {
    setPageUnread(1);
    setHasMoreUnread(true);

    await fetchPaginatedConversation("unread", true);
  };

  useEffect(() => {
    if (selectedChatId) {
      const loadChat = async () => {
        await getParticularChat();

        // 🔥 Refresh unread ONLY ONCE when chat opens
        if (isUnread === "unread") {
          setPageUnread(1);
          setHasMoreUnread(true);
          await fetchPaginatedConversation("unread", true);
        }
      };

      loadChat();

      const interval = setInterval(() => {
        getParticularChat(); // polling only updates messages
      }, POLLING_INTERVAL);

      return () => clearInterval(interval);
    }
  }, [selectedChatId]);

  // --- Handle call ---
  const handleCall = async (phoneNumber) => {
    if (!phoneNumber) return;

    dispatch(
      setCallData({
        params: {
          To: phoneNumber,
          PatientID: trialInfo.patientID,
          PatientTrialJuncID: trialInfo.patientTrialJuncID,
          UserID: user.userProfile.userID,
        },
        trialInfo,
        call: true,
        route: `/conversation-list/${trialInfo.patientTrialJuncID}`,
      }),
    );
  };

  useEffect(() => {
    if (selectedFilter.length === 0) {
      console.log("selectedFilter.length", selectedFilter.length);
      setApplyFilters(false);
    }
  }, [selectedFilter]);

  return (
    <>
      <Header
        headertitle="Conversations"
        showClose={showClose}
        isSearch={true}
        search={search}
        setSearch={setSearch}
        onSearchClick={onSearchClick}
        onCloseClick={onCloseClick}
      />
      {noRecruiter === true ? (
        <div className="h-[calc(100vh-80px)] w-full flex flex-col items-center justify-center no-conversation actual-img-ratio">
          <img src={NoConversation} alt="" />
          <p className="mt-1 text-sm font-medium">No Conversations yet</p>
        </div>
      ) : (
        <div className="flex flex-row justify-content bg-white h-[calc(100vh-88px)] hover:bg-[#6D6BE61A]">
          <LeftConversationList
            initialLoadComplete={initialLoadComplete}
            PAGE_SIZE={PAGE_SIZE}
            onSelectChat={setSelectedChatId}
            selectedChatId={selectedChatId}
            allTrialUnread={allTrialUnread}
            onSearch={onHandleSearch}
            query={query}
            onClear={clearSearch}
            unreadState={unreadState}
            allTrial={allTrial}
            updateUnreadState={updateUnreadState}
            chatMessages={chatMessages}
            fetchMoreTrials={fetchPaginatedConversation} // pagination function
            hasMore={hasMore} // pagination flag
            hasMoreUnread={hasMoreUnread}
            loading={listLoading} // pagination loading
            isUnread={isUnread}
            setIsUnread={setIsUnread}
            getAllTrialUnread={getAllTrialUnread}
            callDispatchRef={callDispatchRef}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            prevSelectedFilter = {prevSelectedFilter}
            setPrevSelectedFilter = {setPrevSelectedFilter}
            isApplyFilters={isApplyFilters}
            setApplyFilters={setApplyFilters}
          />

          <ChatBody
            handleCall={handleCall}
            trialInfo={trialInfo}
            id={selectedChatId}
            conversation={getConversation}
            iSeclinProSync={
              trialInfo?.iSeclinProSync ||
              trialInfo?.eclinProSyncStatus === "failed"
                ? true
                : false
            }
            eclinProSyncStatus={trialInfo?.eclinProSyncStatus}
            eclinProSyncResult={trialInfo?.eclinProSyncResult}
          />
        </div>
      )}
    </>
  );
};

export default ConversationList;
